// ── Track list ──
// Добавь URL аудиофайлов в поле `url` (mp3/ogg/wav). Пока пустые — плеер покажет ссылку на Spotify.
export const TRACKS = [
  { t: 'Jasmine', f: '', y: '2026', d: '3:10', url: '' },
  { t: "What's Going On", f: '', y: '2026', d: '3:18', url: '' },
  { t: 'Freed From Desire', f: 'Alex Alta · Niki Four', y: '2025', d: '2:58', url: '' },
  { t: 'Dreamers', f: '', y: '2025', d: '3:05', url: '' },
  { t: "I Don't Love You", f: 'DNDM', y: '2025', d: '3:32', url: '' },
  { t: 'By Your Side', f: 'DJ Nejtrino · DJ Peretse', y: '2025', d: '3:03', url: '' },
  { t: 'Heartbreak', f: 'Alex Shik · Chique', y: '2025', d: '2:54', url: '' },
  { t: 'Deep Feelings', f: 'LAVRAN · Andeen K', y: '2025', d: '2:48', url: '' },
  { t: 'Run This Town', f: 'Tim Dian · ishoom', y: '2024', d: '1:50', url: '' },
  { t: 'Summer deja vu', f: 'Vadim Adamov · Hardphol', y: '2024', d: '2:52', url: '' },
  { t: 'Illusion', f: 'Kaskeiyp', y: '2024', d: '2:59', url: '' },
  { t: 'Бомондом', f: '', y: '2023', d: '3:15', url: '' },
  { t: 'Тебя люблю', f: 'Alexwave', y: '2023', d: '3:22', url: '' },
  { t: 'Пара', f: '', y: '2022', d: '3:40', url: '' },
];

// ── Gallery items ──
export const GALLERY_ITEMS = [
  { l: 'Ярче звезд', c: 'TV SHOW', img: '/images/gal-tvshow.webp', g: 'linear-gradient(135deg,#1a0800,#C4944A 50%,#0a0500)' },
  { l: 'Live on Stage', c: 'LIVE', img: '/images/hero-bg.webp', g: 'linear-gradient(135deg,#0a0014,#E94560 50%,#0a0014)' },
  { l: 'Red Carpet', c: 'EVENT', img: '/images/gal-redcarpet.webp', g: 'linear-gradient(135deg,#0a0a0a,#3a2a1a 50%,#0a0a0a)' },
  { l: "I Don't Love You", c: 'MUSIC VIDEO', img: '/images/video-idontloveyou.webp', video: 'https://www.youtube.com/embed/EQlxNtHlvNs', g: 'linear-gradient(135deg,#0f0c29,#302b63 50%,#24243e)' },
  { l: 'Deep Feelings', c: 'MUSIC VIDEO', img: '/images/video-deep-feelings.webp', video: 'https://www.youtube.com/embed/4jWZ_mnWjAk', g: 'linear-gradient(135deg,#000,#2d1f0f 50%,#000)' },
  { l: 'Behind the Scenes', c: 'STUDIO', img: '/images/gal-studio.webp', g: 'linear-gradient(135deg,#1a0a1a,#4a2a3a 50%,#0a0a0a)' },
  { l: 'Performance', c: 'LIVE', img: '/images/gal-performance.webp', g: 'linear-gradient(135deg,#0a0a0a,#1a3a2a 50%,#0a0a0a)' },
  { l: 'Award Ceremony', c: 'CEREMONY', img: '/images/gal-ceremony.webp', g: 'linear-gradient(135deg,#0a0a1a,#1a2a4a 50%,#0a0a0a)' },
];

// ── Social links ──
export const SOCIALS = [
  { n: 'Instagram', u: 'https://www.instagram.com/juliamilows/' },
  { n: 'YouTube', u: 'https://youtube.com/c/JuliaMilows' },
  { n: 'Spotify', u: 'https://open.spotify.com/artist/2JfnSnLG9WTRq77gICScuP' },
  { n: 'Apple Music', u: 'https://music.apple.com/us/artist/julia-milows/1649356457' },
  { n: 'Яндекс.Музыка', u: 'https://music.yandex.ru/artist/juliamilows' },
  { n: 'VK Музыка', u: 'https://vk.ru/artist/juliamilows' },
  { n: 'Telegram', u: 'https://t.me/juliamilowss' },
];

// ── Stats for About section ──
export const STATS = [
  { n: 500, s: '+', l: ['Выступлений', 'Shows'] },
  { n: 25, s: '+', l: ['Релизов', 'Releases'] },
  { n: 50, s: '+', l: ['Городов', 'Cities'] },
  { n: 2, s: 'M+', l: ['Слушателей', 'Listeners'] },
];

// ── External links ──
export const LINKS = {
  spotify: 'https://open.spotify.com/artist/2JfnSnLG9WTRq77gICScuP',
  appleMusic: 'https://music.apple.com/us/artist/julia-milows/1649356457',
  instagram: 'https://www.instagram.com/juliamilows/',
  youtube: 'https://youtube.com/c/JuliaMilows',
  soundbetter: 'https://soundbetter.com/profiles/589207-julia-milows',
  email: 'booking@juliamilows.com',
  telegram: 'https://t.me/juliamilows',
};
